import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, saveIntakeAnswersApi, getIntakeAnswersApi } from "../utils/Constants";

const authHeaders = () => ({
  Authorization: localStorage.getItem("token"),
  "Access-Control-Allow-Origin": "*",
});

export const saveIntakeAnswers = createAsyncThunk(
  "intakeAnswer/save",
  async (payload) => {
    try {
      const response = await axios.post(
        ApiBaseUrl + saveIntakeAnswersApi,
        payload,
        { headers: authHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
);

export const getIntakeAnswers = createAsyncThunk(
  "intakeAnswer/get",
  async ({ projectId, patientId, serviceType }) => {
    try {
      const params = { projectId };
      if (patientId) params.patientId = patientId;
      if (serviceType) params.serviceType = serviceType;
      const response = await axios.get(ApiBaseUrl + getIntakeAnswersApi, {
        headers: authHeaders(),
        params,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
);

const intakeAnswerSlice = createSlice({
  name: "intakeAnswer",
  initialState: {
    isSaving: false,
    isFetching: false,
    saveData: null,
    answers: [],
    error: null,
  },
  reducers: {
    clearIntakeAnswers: (state) => {
      state.saveData = null;
      state.answers = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveIntakeAnswers.pending, (state) => { state.isSaving = true; state.error = null; })
      .addCase(saveIntakeAnswers.fulfilled, (state, action) => { state.isSaving = false; state.saveData = action.payload; })
      .addCase(saveIntakeAnswers.rejected, (state, action) => { state.isSaving = false; state.error = action.error; })
      .addCase(getIntakeAnswers.pending, (state) => { state.isFetching = true; state.error = null; })
      .addCase(getIntakeAnswers.fulfilled, (state, action) => { state.isFetching = false; state.answers = action.payload?.data || []; })
      .addCase(getIntakeAnswers.rejected, (state, action) => { state.isFetching = false; state.error = action.error; });
  },
});

export const { clearIntakeAnswers } = intakeAnswerSlice.actions;
export default intakeAnswerSlice.reducer;